export default {
  clearApplicationState({ commit }) {
    commit('resetLocationDates')
    commit('resetPerilUuids')
    commit('resetActivePerils')
    commit('setMode', '')
    commit('setTagUuid', '')
    commit('setPcsNumber', '')
    commit('setDescription', '')
    commit('setLoadedData', false)
    commit('setTagType', '')
    commit('setPcsNumber', '')
    commit('setDescription', '')
    commit('setLoadedData', false)
  },
}
